module.exports = __webpack_public_path__ + "media/images/panel-c87a757847c589c4eb2a880896e3c5c7.png";